import * as React from 'react';

function SvgTotalMatchPlayed(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={35} height={35} {...props}>
      <defs>
        <style>
          {
            '.total_match_played_svg__prefix__cls-3{fill:#ff4893}.total_match_played_svg__prefix__cls-4{fill:#c7463b}.total_match_played_svg__prefix__cls-6{fill:#ebebeb}'
          }
        </style>
      </defs>
      <g id="total_match_played_svg__prefix__total_match_played" transform="translate(-24 -444)">
        <path
          id="total_match_played_svg__prefix__bound"
          fill="none"
          d="M0 0h35v35H0z"
          transform="translate(24 444)"
        />
        <g id="total_match_played_svg__prefix__match" transform="translate(25 448.5)">
          <path
            id="total_match_played_svg__prefix__Path_5315"
            fill="#ff9a14"
            d="M122.525 53.2a10.064 10.064 0 11-10.063-10.06 10.064 10.064 0 0110.063 10.06zm0 0"
            data-name="Path 5315"
            transform="translate(-95.689 -39.846)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5316"
            d="M349.867 137.008h10.063v7.827h-10.063zm0 0"
            className="total_match_played_svg__prefix__cls-3"
            data-name="Path 5316"
            transform="translate(-326.945 -127.564)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5317"
            d="M190.383 165.677a.559.559 0 01-.53-.382l-1.677-5.032 1.062-.353 1.145 3.441 1.147-3.441 1.062.353-1.677 5.032a.559.559 0 01-.532.382zm0 0"
            className="total_match_played_svg__prefix__cls-4"
            data-name="Path 5317"
            transform="translate(-175.847 -148.965)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5318"
            d="M266.771 168.2h-2.236v-1.118h2.236a.559.559 0 000-1.118h-.559a1.677 1.677 0 010-3.354h1.677v1.118h-1.677a.559.559 0 000 1.118h.559a1.677 1.677 0 010 3.354zm0 0"
            className="total_match_played_svg__prefix__cls-4"
            data-name="Path 5318"
            transform="translate(-247.204 -151.488)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5319"
            fill="#b3e4e8"
            d="M72.928 26.212l-.03-1.118q.269-.007.534-.025l.079 1.115c-.192.015-.39.023-.584.028zm-1.17-.022c-.2-.012-.391-.03-.582-.051l.121-1.111c.177.019.354.035.533.047zm2.915-.14l-.18-1.1c.177-.028.352-.061.525-.1l.23 1.094c-.192.04-.384.076-.578.107zm-4.652-.091q-.287-.056-.571-.13l.272-1.085q.259.064.521.118zm6.361-.309l-.328-1.069q.256-.079.507-.168l.377 1.053q-.277.1-.558.184zm-8.051-.158q-.279-.1-.549-.208l.42-1.036c.168.067.331.13.5.189zm9.685-.473l-.473-1.013c.161-.075.321-.154.478-.236l.519.991q-.257.136-.524.258zm-11.3-.224q-.261-.134-.515-.279l.559-.969c.154.088.311.174.47.256zm12.838-.624l-.606-.94q.224-.144.442-.3l.649.911q-.236.171-.482.33zm-14.337-.283a13.265 13.265 0 01-.471-.347l.683-.886c.142.112.285.215.431.318zm15.744-.764l-.727-.851q.2-.173.4-.356l.766.815c-.143.134-.287.264-.436.391zm-17.108-.339q-.215-.2-.421-.408l.8-.783c.125.127.252.251.383.372zm18.36-.889l-.833-.746q.177-.2.344-.405l.869.7c-.125.152-.252.3-.381.448zm-19.56-.391c-.124-.15-.245-.3-.362-.461l.894-.671q.159.213.329.42zm20.636-1l-.93-.62q.149-.224.288-.452l.954.579c-.1.168-.206.335-.314.5zm-21.654-.426q-.152-.248-.294-.5l.977-.543c.087.157.177.31.27.462zm22.531-1.094l-1.007-.489q.117-.24.224-.487l1.027.444q-.12.274-.248.536zm-23.346-.46q-.118-.267-.224-.541l1.043-.4.2.491zm24-1.169l-1.062-.347c.056-.168.107-.339.154-.511l1.078.3q-.083.286-.174.564zm-24.6-.48q-.08-.279-.147-.566l1.089-.255q.06.261.134.517zm25.024-1.218l-1.1-.2q.048-.263.083-.528l1.109.15c-.025.195-.056.388-.091.579zm-25.386-.5q-.04-.288-.068-.579l1.113-.1q.026.268.063.532zm25.58-1.244l-1.118-.048c.007-.168.011-.339.011-.509l1.118-.026v.024q.003.283-.009.562zm-25.704-.504v-.052q0-.294.013-.584l1.118.049c-.008.177-.013.356-.013.535zm24.549-1.144a10.387 10.387 0 00-.061-.531l1.107-.154q.04.289.068.581zm-23.324-.507l-1.108-.15c.026-.2.056-.387.093-.58l1.1.2c-.033.178-.061.353-.085.53zm23.068-1.073q-.061-.262-.133-.518l1.077-.3q.078.279.145.566zm-22.743-.496l-1.076-.3c.052-.189.112-.376.168-.559l1.062.351q-.082.25-.154.508zm22.275-1.036l-.2-.494 1.025-.447c.078.177.15.357.22.539zm-21.74-.472l-1.025-.447q.117-.269.246-.532l1.006.491q-.119.244-.227.488zM82.885 7.7q-.128-.235-.268-.462l.954-.583q.151.248.293.5zm-20.328-.443l-.957-.582c.1-.168.206-.33.314-.491l.929.621q-.149.226-.289.455zm19.461-.9q-.159-.215-.328-.42l.866-.708q.186.224.36.462zm-18.536-.4l-.867-.707q.185-.224.38-.447l.835.744q-.179.206-.348.413zm17.5-.81q-.187-.191-.382-.373l.762-.818q.215.2.419.408zm-16.4-.36l-.765-.814q.213-.2.436-.391l.727.851q-.2.173-.4.355zm15.2-.706a7.878 7.878 0 00-.427-.318L80 2.841q.241.167.473.35zm-13.963-.314l-.646-.912c.159-.112.32-.224.485-.328l.6.941q-.226.145-.443.3zm12.635-.587q-.233-.134-.47-.257l.516-.992q.259.135.513.279zm-11.267-.247l-.521-.992a12.1 12.1 0 01.524-.257l.471 1.016c-.159.074-.319.153-.477.235zm9.823-.456c-.168-.067-.332-.13-.5-.191l.374-1.054q.277.1.548.21zm-8.361-.182l-.374-1.054c.183-.065.368-.125.555-.183l.328 1.069q-.255.079-.506.168zm6.838-.318a10.916 10.916 0 00-.52-.119l.223-1.1q.289.058.571.131zm-5.3-.114l-.226-1.1c.19-.039.381-.074.574-.106l.179 1.1a8.378 8.378 0 00-.525.1zm3.721-.172c-.177-.02-.354-.036-.533-.048l.079-1.118c.2.013.392.03.582.052zm-2.134-.045L71.7.527c.193-.014.388-.022.584-.027l.026 1.118q-.268.008-.533.027zm0 0"
            data-name="Path 5319"
            transform="translate(-55.821)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5320"
            d="M8.535 137.008H18.6v7.827H8.535zm0 0"
            className="total_match_played_svg__prefix__cls-3"
            data-name="Path 5320"
            transform="translate(-7.976 -127.564)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5321"
            d="M8.535 137.008H18.6v3.914H8.535zm0 0"
            className="total_match_played_svg__prefix__cls-6"
            data-name="Path 5321"
            transform="translate(-7.976 -127.564)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5322"
            fill="#008afd"
            d="M349.867 137.008h3.354v7.827h-3.354zm0 0"
            data-name="Path 5322"
            transform="translate(-326.945 -127.564)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5323"
            d="M401.066 137.008h3.354v7.827h-3.354zm0 0"
            className="total_match_played_svg__prefix__cls-6"
            data-name="Path 5323"
            transform="translate(-374.79 -127.564)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5324"
            d="M190.354 163.351l-1.147-3.441-1.062.353 1.677 5.032a.559.559 0 001.062 0l1.677-5.032-1.062-.353zm0 0"
            data-name="Path 5324"
            transform="translate(-175.818 -148.966)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5325"
            d="M266.771 164.842h-.559a.559.559 0 010-1.118h1.677v-1.118h-1.677a1.677 1.677 0 000 3.355h.559a.559.559 0 010 1.118h-2.236v1.121h2.236a1.677 1.677 0 000-3.354zm0 0"
            data-name="Path 5325"
            transform="translate(-247.204 -151.484)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5326"
            d="M32.985 40.709h-4.548l.344-.132c-.07-.182-.143-.362-.22-.539l-1.025.447c.032.074.061.15.092.224H26.4a10.615 10.615 0 00-19.261 0H.559a.559.559 0 00-.559.559V49.1a.559.559 0 00.559.559h4.619l-.406.157q.105.273.224.541l1.023-.457c-.036-.08-.068-.164-.1-.246h1.222a10.616 10.616 0 0019.262 0h6.582a.559.559 0 00.559-.559v-7.827a.559.559 0 00-.559-.559zM1.118 41.827h8.945v2.8H1.118zm0 6.709v-2.8h8.945v2.8zm15.654 6.15a9.509 9.509 0 01-8.386-5.032h2.236a.559.559 0 00.559-.559v-7.827a.559.559 0 00-.559-.559H8.386a9.5 9.5 0 0116.772 0h-2.236a.559.559 0 00-.559.559V49.1a.559.559 0 00.559.559h2.236a9.487 9.487 0 01-8.386 5.032zm8.945-6.15h-2.236v-6.709h2.236zm3.355 0h-2.236v-6.709h2.236zm3.354 0H30.19v-6.709h2.236zm0 0"
            data-name="Path 5326"
            transform="translate(0 -31.824)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5327"
            d="M243.006.535c-.2 0-.391.013-.584.027l.078 1.118q.265-.018.535-.025zm0 0"
            data-name="Path 5327"
            transform="translate(-226.539 -.032)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5328"
            d="M166.106 18.566c-.177.083-.352.168-.524.257l.515.992c.158-.082.318-.16.479-.235zm0 0"
            data-name="Path 5328"
            transform="translate(-154.734 -16.882)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5329"
            d="M268.1.91l-.076 1.118q.268.018.533.048l.125-1.111a10.227 10.227 0 00-.582-.054zm0 0"
            data-name="Path 5329"
            transform="translate(-250.464 -.383)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5330"
            d="M143.215 31.449a9.993 9.993 0 00-.484.328l.646.912q.217-.154.442-.3zm0 0"
            data-name="Path 5330"
            transform="translate(-133.38 -28.921)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5331"
            d="M316.168 11.672l-.375 1.054q.251.091.5.191l.422-1.035q-.273-.111-.55-.21zm0 0"
            data-name="Path 5331"
            transform="translate(-295.104 -10.439)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5332"
            d="M75.945 111.007l1.025.447q.107-.246.224-.486l-1.007-.492q-.127.261-.243.531zm0 0"
            data-name="Path 5332"
            transform="translate(-70.97 -102.771)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5333"
            d="M372.574 327.758l.727.851c.149-.127.294-.258.436-.391l-.766-.815q-.193.182-.397.355zm0 0"
            data-name="Path 5333"
            transform="translate(-348.164 -305.484)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5334"
            d="M394.855 73.364q.168.206.328.42l.9-.666q-.174-.235-.36-.462zm0 0"
            data-name="Path 5334"
            transform="translate(-368.985 -67.428)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5335"
            d="M359.81 36.238l-.643.914c.145.1.287.208.427.318l.689-.882q-.232-.18-.473-.35zm0 0"
            data-name="Path 5335"
            transform="translate(-335.636 -33.396)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5336"
            d="M332.068 355.664c-.157.082-.317.16-.478.236l.473 1.013q.265-.122.524-.258zm0 0"
            data-name="Path 5336"
            transform="translate(-309.865 -331.894)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5337"
            d="M338.761 22.336l-.515.992q.238.124.47.257l.559-.969q-.254-.148-.514-.281zm0 0"
            data-name="Path 5337"
            transform="translate(-316.085 -20.405)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5338"
            d="M234.465 374.855l-.121 1.111c.193.021.387.039.582.051L235 374.9c-.181-.01-.356-.026-.535-.045zm0 0"
            data-name="Path 5338"
            transform="translate(-218.99 -349.828)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5339"
            d="M292.508 4.5l-.223 1.1c.174.036.348.075.52.119l.276-1.083q-.285-.072-.573-.131zm0 0"
            data-name="Path 5339"
            transform="translate(-273.135 -3.741)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5340"
            d="M208.793 370.657a11.54 11.54 0 01-.521-.118l-.272 1.085q.283.071.571.13zm0 0"
            data-name="Path 5340"
            transform="translate(-194.373 -345.795)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5341"
            d="M190.668 9.008c-.187.056-.372.118-.555.183l.375 1.054q.251-.089.508-.168zm0 0"
            data-name="Path 5341"
            transform="translate(-177.658 -7.95)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5342"
            d="M103.715 66.566l.867.707q.168-.207.348-.408l-.835-.743q-.195.219-.38.445zm0 0"
            data-name="Path 5342"
            transform="translate(-96.92 -61.321)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5343"
            d="M123.132 48.249l-.732-.849q-.223.191-.436.391l.764.817c.135-.125.272-.243.404-.359zm0 0"
            data-name="Path 5343"
            transform="translate(-113.978 -43.825)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5344"
            d="M88.262 87.777l.954.582q.14-.23.289-.452l-.929-.621c-.108.161-.214.324-.314.491zm0 0"
            data-name="Path 5344"
            transform="translate(-82.479 -81.099)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5345"
            d="M216.476 2.957a15.29 15.29 0 00-.574.106l.227 1.1c.174-.036.349-.069.526-.1zm0 0"
            data-name="Path 5345"
            transform="translate(-201.757 -2.296)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5346"
            d="M285.513 372.117c-.173.036-.348.069-.525.1l.179 1.1c.193-.031.385-.068.576-.107zm0 0"
            data-name="Path 5346"
            transform="translate(-266.317 -347.269)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5347"
            d="M261.175 375.488q-.265.018-.535.025l.03 1.118c.2-.006.391-.014.584-.029zm0 0"
            data-name="Path 5347"
            transform="translate(-243.565 -350.419)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5348"
            d="M309.3 365.461q-.251.091-.507.168l.328 1.069q.28-.086.556-.185zm0 0"
            data-name="Path 5348"
            transform="translate(-288.558 -341.049)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5349"
            d="M410.251 95.022q-.142-.255-.293-.5L409 95.1q.139.227.268.462zm0 0"
            data-name="Path 5349"
            transform="translate(-382.207 -87.859)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5350"
            d="M117.293 322.852a11.202 11.202 0 01-.383-.372l-.8.783q.206.21.421.408zm0 0"
            data-name="Path 5350"
            transform="translate(-108.506 -300.884)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5351"
            d="M390.023 309.92l.833.746c.132-.146.258-.3.381-.447l-.869-.7q-.168.203-.345.401zm0 0"
            data-name="Path 5351"
            transform="translate(-364.47 -288.769)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5352"
            d="M418.418 268.2l-1.027-.444q-.107.247-.224.487l1.006.489q.127-.264.245-.532zm0 0"
            data-name="Path 5352"
            transform="translate(-389.836 -249.743)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5353"
            d="M353.414 342.9q-.216.154-.442.3l.606.94q.246-.159.484-.329zm0 0"
            data-name="Path 5353"
            transform="translate(-329.847 -319.964)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5354"
            d="M404.965 289.952l.93.62c.108-.163.214-.326.314-.494l-.957-.577q-.138.229-.287.451zm0 0"
            data-name="Path 5354"
            transform="translate(-378.433 -270.065)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5355"
            d="M98.68 304.578c.116.156.238.311.362.461l.864-.709q-.168-.207-.329-.42zm0 0"
            data-name="Path 5355"
            transform="translate(-92.215 -283.531)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5356"
            d="M84.164 283.906q.142.256.294.5l.953-.585a12.392 12.392 0 01-.27-.462zm0 0"
            data-name="Path 5356"
            transform="translate(-78.65 -264.33)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5357"
            d="M378.145 53.95q.2.183.383.373l.8-.783q-.2-.209-.419-.408zm0 0"
            data-name="Path 5357"
            transform="translate(-353.37 -49.184)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5358"
            d="M182.913 362.961l-.421 1.039q.273.112.55.208l.371-1.055a13.593 13.593 0 01-.5-.192zm0 0"
            data-name="Path 5358"
            transform="translate(-170.536 -338.713)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5359"
            d="M158.946 352.27l-.559.969q.255.146.515.279l.512-.994a11.17 11.17 0 01-.468-.254zm0 0"
            data-name="Path 5359"
            transform="translate(-148.01 -328.723)"
          />
          <path
            id="total_match_played_svg__prefix__Path_5360"
            d="M137.281 338.979a9.945 9.945 0 01-.431-.318l-.683.885c.154.119.311.235.471.347zm0 0"
            data-name="Path 5360"
            transform="translate(-127.247 -316.005)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgTotalMatchPlayed;
